// The classifier's version is the pair of its algorithm and its dictionary.
// Either changing can move an item to another aisle, so either bumps the
// version. Every classification names the version that made it, and the
// held-out results are pinned against it. A new version never changes a
// category already on an item: the fill only ever writes a blank one (g81).

import { DICTIONARY_REVISION } from "./dictionary.js";

// 2 (g79): a category that names an aisle places the item there.
// 3 (g80): spelling tolerance for five to seven letters forgives a missing,
// extra or swapped letter but not a changed one, and "frozen" moves a ready
// meal to Frozen.
export const ALGORITHM_REVISION = 3;
export { DICTIONARY_REVISION };
export const CLASSIFIER_VERSION = `grocery-a${ALGORITHM_REVISION}.d${DICTIONARY_REVISION}`;
/**
 * The same pair as one number, for activity history (g105), whose contract
 * keeps a fill's classifier version as an integer: the algorithm's revision
 * in the thousands and the dictionary's below. `a3.d2` is 3002.
 */
export const CLASSIFIER_VERSION_NUMBER = ALGORITHM_REVISION * 1000 + DICTIONARY_REVISION;
